import { React } from "react";
import { Col, Row } from "reactstrap";

const MainNavigation = ({ title }) => {
  return (
    <Row className="px-1 py-3 m-0 d-flex justify-content-center align-items-center">
      <Col className="col-10 m-0 py-0 px-0 d-flex justify-content-center">
        <h2
          className="fs--25 fw--600 mb-0 normal-heading"
        >
          {title || ""}
        </h2>
      </Col>
    </Row>
  );
};

export default MainNavigation;
